import { getLegsWithReservations } from '@state/queries/journey-legs/get-legs-with-reservations'

export const legsWithReservation = () => {
  const legs = getLegsWithReservations()
  if (!legs) return []

  return legs.map((leg) => legReservationParams(leg))
}

export const legReservationParams = (leg) => {
  return {
    dep: {
      // eslint-disable-next-line camelcase
      station: leg.board_station?.crs_code || leg.board_station_id,
      time: leg.scheduled_departure,
    },
    arr: {
      // eslint-disable-next-line camelcase
      station: leg.alight_station?.crs_code || leg.alight_station_id,
      time: leg.scheduled_arrival,
    },
    rars_leg_id: leg.rars_leg_id,
    reservation: reservationParams(leg),
  }
}

const reservationParams = (leg) => {
  const { coach, reservations, reservation_source: source, seats } = leg

  return {
    coach,
    reservations,
    source,
    seats,
  }
}
